export default __webpack_public_path__ + "static/george-b590eb0ff78e0bd90c5f53ccad314d7a.jpg";